export default "__VITE_ASSET__Beq79reN__"